import React from 'react';
import { Spinner } from 'ui/component/Spinner.tsx';

type TablePaginationProps = {
  isErrored: boolean;
  rowsCount?: number;
  tableData: any[];
  pagination: boolean;
  isValidating: boolean;
  isRefetchLoading: boolean;
  fetchNextPage: () => void;
  fetchAll?: () => void;
  t: (key: string, options?: any) => string;
  rows: any[];
};

export const TablePagination: React.FC<TablePaginationProps> = ({
  isErrored,
  rowsCount,
  tableData,
  pagination,
  isValidating,
  isRefetchLoading,
  fetchNextPage,
  fetchAll,
  t,
  rows,
}) => {
  if (isErrored) return null;

  return (
    <div className="relative mx-auto mt-4 flex flex-row items-end justify-center gap-2">
      {rowsCount === undefined && <Spinner size={18} />}
      {rowsCount !== undefined && (
        <React.Fragment>
          <span>{t('table.pagination.showing', { shown: tableData?.length ?? 0, total: rowsCount })}</span>
          {pagination && rowsCount && rows.length < rowsCount && (
            <>
              <button className="cursor-pointer text-blue-600 underline disabled:cursor-default disabled:text-grey-label" disabled={isValidating} onClick={fetchNextPage}>
                {t('table.pagination.loadMore')}
              </button>
              {isRefetchLoading && <Spinner size={18} />}
              {fetchAll && (
                <button
                  className="absolute right-0 cursor-pointer text-blue-600 underline disabled:cursor-default disabled:text-grey-label"
                  disabled={isValidating}
                  onClick={fetchAll}
                >
                  {t('table.pagination.loadAll')}
                </button>
              )}
            </>
          )}
        </React.Fragment>
      )}
    </div>
  );
};
